var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.modal_id,"title":_vm.title,"size":"xl"},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
var cancel = ref.cancel;
var hide = ref.hide;
return undefined}}])},[_c('b-overlay',{attrs:{"show":_vm.loading}},[(!_vm.error)?_c('div',[_c('iframe',{ref:"orderingPolicies",staticClass:"w-100",attrs:{"src":_vm.src,"height":"800px"}})]):_c('b-alert',{attrs:{"show":""}},[_vm._v(_vm._s(_vm.error))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }